export const defaultAcceptPropMap = {
  style: false,
  className: true,
  tabindex: true,
  title: true,
  itemid: true,
  itemprop: true,
  itemref: true,
  itemscope: true,
  itemtype: true,
  id: true,
  hidden: true,
  contenteditable: true,
  inputmode: true,
  accesskey: true,
  autocapitalize: true,
}

export const acceptPropMap = {
  ...defaultAcceptPropMap,
  accept: true,
  alt: true,
  autocomplete: true,
  autofocus: true,
  capture: true,
  checked: true,
  dirname: true,
  disabled: true,
  form: true,
  formaction: true,
  formenctype: true,
  formmethod: true,
  formnovalidate: true,
  formtarget: true,
  height: true,
  list: true,
  max: true,
  maxlength: true,
  min: true,
  minlength: true,
  multiple: true,
  name: true,
  pattern: true,
  placeholder: true,
  readonly: true,
  size: true,
  src: true,
  step: true,
  type: true,
  value: true,
  defaultValue: true,
  width: true,
  onFocus: true,
  onBlur: true,
  onKeyDown: true,
  onKeyUp: true,
  onKeyPress: true,
}

/**
 * Filter the non explicitly handled props
 */
export function filterAvailableProps(props) {
  const allowedProps = {}

  Object.entries(props).forEach(([k, v]) => {
    const isAllowed = k.startsWith("data-") || k.startsWith("aria-") || acceptPropMap[k]

    if (isAllowed) {
      allowedProps[k] = v
    }
  })

  return allowedProps
}
